export default "__VITE_ASSET__BNSxTK5R__"